import { useSelector } from 'react-redux';
import { AppBase } from '../../../../../../shared/frontend/components/appBase';
import SharedCookieFooter from '../../../../../../shared/frontend/components/presentational/cookieFooter';
import { AuthBar } from '../container/authBar';
import LoadableQueueModalContainer from '../container/loadableQueueModalContainer';
import MainNavBar from '../container/mainNavBar';
import SiteFooter from './siteFooter';

const CookieFooter = () => <SharedCookieFooter policyLinksVariant="external" />;

const App = (props: any) => {
  const queueModalIsOpen = useSelector((state: any) => state.queueModal.isOpen);

  return (
    <AppBase
      {...props}
      authBarComponent={AuthBar}
      navBarComponent={MainNavBar}
      siteFooterComponent={SiteFooter}
      cookieFooterComponent={CookieFooter}
      preContentComponents={<>{queueModalIsOpen && <LoadableQueueModalContainer />}</>}
    />
  );
};

export default App;
